import React from 'react'
import useTrans from '@hooks/useTrans'
import { DistributoreNode } from '@gql/graphql-get'
import styles from './DistributoreCard.module.sass'
import { BertoliniLogo, EfcoLogo, NibbiLogo, OleomacLogo } from '@components/icons'
import { handleStoreLocatorDetailsTracking } from '@utils/tracking'

interface Props {
  distributore?: DistributoreNode
  selected?: boolean
  onClick?: () => void
  className?: string
}

const DistributoreCard = (props: Props) => {
  const { distributore = undefined, selected = false, onClick = undefined, className = '' } = props
  const t = useTrans()

  const details = [
    // {
    //   label: t('Indirizzo'),
    //   value: [
    //     distributore.indirizzo,
    //     distributore.cap,
    //     [distributore.localita, distributore.citta, distributore.provincia]
    //       .filter((x) => !!x)
    //       .join(' '),
    //   ]
    //     .filter((x) => !!x)
    //     .map((x, index) => (
    //       <>
    //         {index > 0 ? <br /> : <></>}
    //         {x}
    //       </>
    //     )),
    // },
    {
      label: t('Telefono'),
      value: distributore.telefono || undefined,
    },
    {
      label: t('Email'),
      value: distributore?.email ? (
        <a
          href={`mailto:${distributore.email}`}
          onClick={() =>
            handleStoreLocatorDetailsTracking(
              distributore.nome,
              'email',
              `${distributore.continente}_${distributore.nazione}`
            )
          }
        >
          {distributore.email}
        </a>
      ) : undefined,
    },
    {
      label: t('Web'),
      value:
        distributore.sitiWeb?.length > 0
          ? distributore.sitiWeb.map((sito, index) => (
              <React.Fragment key={index}>
                {index > 0 && <span>, </span>}
                <a
                  href={/^https?:\/\//.test(sito) ? sito : `https://${sito}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() =>
                    handleStoreLocatorDetailsTracking(
                      distributore.nome,
                      'web',
                      `${distributore.continente}_${distributore.nazione}`
                    )
                  }
                >
                  {sito}
                </a>
              </React.Fragment>
            ))
          : undefined,
    },
  ].filter((x) => !!x.value)

  return distributore ? (
    <div
      className={`${styles.root} ${selected ? styles['root--selected'] : ''} ${className}`}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === 'Enter') onClick()
            }
          : undefined
      }
      id={`distributoreCard-storeLocator-${distributore.pk}`}
    >
      <div className={styles.main}>
        {!!distributore.ragioneSociale && (
          <h3 className={styles.title}>{distributore.ragioneSociale}</h3>
        )}

        {!!distributore.indirizzo && (
          <div className={styles.detailItem}>
            {distributore.indirizzo},{!!distributore.cap && ` ${distributore.cap}`}
            {!!distributore.citta && ` - ${distributore.citta}`}
          </div>
        )}

        {!!details?.length && (
          <div className={styles.details}>
            {details.map((x) => (
              <div className={styles.detailItem}>
                <strong>{x.label}:</strong> {x.value}
              </div>
            ))}
          </div>
        )}

        {!!distributore?.sites && distributore?.sites.length > 0 && (
          <div className={styles.sites}>
            {distributore.sites.map((site) => {
              switch (site.id) {
                case '1':
                  return <EfcoLogo key={site.id} className={styles.siteLogo} />
                case '2':
                  return <OleomacLogo key={site.id} className={styles.siteLogo} />
                case '3':
                  return <BertoliniLogo key={site.id} className={styles.siteLogo} />
                case '4':
                  return <NibbiLogo key={site.id} className={styles.siteLogo} />
                default:
                  return <></>
              }
            })}
          </div>
        )}
      </div>
    </div>
  ) : (
    <></>
  )
}

export default DistributoreCard
